var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchMakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1875_195840)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1875_195840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9446 40.88C58.9446 34.1724 53.4876 28.7153 46.7799 28.7153C40.0723 28.7153 34.6152 34.1723 34.6152 40.88C34.6152 46.8472 38.9341 51.8244 44.6101 52.8506V54.0569H42.1223C40.9239 54.0569 39.9524 55.0284 39.9524 56.2268C39.9524 57.4252 40.9239 58.3966 42.1223 58.3966H44.6101V58.87C44.6101 60.0684 45.5816 61.0399 46.7799 61.0399C47.9783 61.0399 48.9498 60.0684 48.9498 58.87V58.3966H51.4376C52.636 58.3966 53.6075 57.4252 53.6075 56.2268C53.6075 55.0284 52.636 54.0569 51.4376 54.0569H48.9498V52.8506C54.6257 51.8244 58.9446 46.8472 58.9446 40.88ZM38.9549 40.88C38.9549 36.5653 42.4652 33.055 46.7799 33.055C51.0947 33.055 54.6049 36.5653 54.6049 40.88C54.6049 45.1946 51.0946 48.7049 46.7799 48.7049C42.4652 48.7049 38.9549 45.1947 38.9549 40.88Z",
    fill: "url(#paint0_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3883 28.9094V26.1854L35.0612 26.9051C36.1623 27.3787 37.4384 26.8701 37.9119 25.7693C38.3855 24.6685 37.877 23.3922 36.7762 22.9186L32.0887 20.9021C31.8481 20.7966 31.5904 20.7358 31.328 20.7228C31.255 20.719 31.1819 20.719 31.1089 20.7228C30.8394 20.7362 30.5831 20.7991 30.3483 20.9021L25.6607 22.9186C24.5598 23.3922 24.0513 24.6685 24.5249 25.7693C24.8783 26.5907 25.6784 27.0822 26.5192 27.0822C26.8052 27.0822 27.0961 27.0253 27.3756 26.9051L29.0486 26.1854V28.9094C23.3726 29.9356 19.0537 34.9128 19.0537 40.88C19.0537 47.5876 24.5107 53.0447 31.2184 53.0447C37.9261 53.0447 43.3831 47.5877 43.3831 40.88C43.3831 34.9128 39.0643 29.9356 33.3883 28.9094ZM31.2184 48.7049C26.9037 48.7049 23.3935 45.1946 23.3935 40.88C23.3935 36.5654 26.9038 33.0551 31.2184 33.0551C35.5331 33.0551 39.0434 36.5654 39.0434 40.88C39.0434 45.1946 35.5331 48.7049 31.2184 48.7049Z",
    fill: "url(#paint1_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7483 25.7693C34.623 26.0614 34.4348 26.3223 34.1971 26.5333L35.0615 26.9051C36.1626 27.3787 37.4387 26.8701 37.9122 25.7693C38.3858 24.6685 37.8773 23.3922 36.7764 22.9186L32.0889 20.9021C31.8483 20.7966 31.5906 20.7358 31.3282 20.7228C31.2552 20.719 31.1821 20.719 31.1091 20.7228C30.8396 20.7362 30.5833 20.7991 30.3485 20.9021L29.6367 21.2083L33.6125 22.9186C34.7133 23.3922 35.2218 24.6685 34.7483 25.7693Z",
    fill: "url(#paint2_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3886 28.9094V26.1854L32.1431 25.6937C31.2222 25.3302 30.2247 26.0089 30.2247 26.9989C30.2247 28.0554 30.8938 29.0025 31.896 29.3368C35.0061 30.3744 37.5611 32.6363 38.987 35.5476C38.5471 35.8532 38.1278 36.1873 37.7317 36.5478C38.5601 37.789 39.0437 39.279 39.0437 40.88C39.0437 41.235 39.0194 41.5845 38.9734 41.9271L38.9834 41.9082C39.2929 41.321 40.1896 41.5874 40.137 42.2491C40.1304 42.3372 40.1215 42.425 40.1104 42.5126C39.38 47.9337 35.0649 52.2338 29.6367 52.9418C30.1546 53.0094 30.6826 53.0446 31.2187 53.0446C37.9264 53.0446 43.3834 47.5876 43.3834 40.8799C43.3835 34.9128 39.0646 29.9356 33.3886 28.9094Z",
    fill: "url(#paint3_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9448 40.88C58.9448 34.1726 53.4874 28.7152 46.78 28.7152C43.8232 28.7152 41.1091 29.7762 38.9983 31.5368C37.8835 32.4666 36.9372 33.5924 36.2122 34.8597C35.1963 36.6361 34.6152 38.6916 34.6152 40.88C34.6152 43.0691 35.1963 45.1247 36.2122 46.9003C37.7396 45.6306 38.7785 43.7925 38.999 41.7133C38.9698 41.4397 38.9548 41.1614 38.9548 40.88C38.9548 40.5985 38.9698 40.3203 38.999 40.0467C39.2196 37.9675 40.2585 36.1293 41.7859 34.8597C43.1417 33.7331 44.8834 33.0547 46.78 33.0547C51.0943 33.0547 54.6045 36.565 54.6045 40.88C54.6045 45.195 51.0943 48.7052 46.78 48.7052C44.8834 48.7052 43.1417 48.0269 41.7859 46.9003C41.0621 48.1648 40.1187 49.29 38.9998 50.2232C40.5818 51.5434 42.5021 52.4692 44.6098 52.8503V54.0567H42.1219C40.9241 54.0567 39.9525 55.0284 39.9525 56.2269C39.9525 57.4254 40.9241 58.3971 42.1219 58.3971H44.6098V58.8698C44.6098 60.0684 45.5815 61.04 46.78 61.04C47.9785 61.04 48.9494 60.0684 48.9494 58.8698V58.3971H51.4374C52.6359 58.3971 53.6075 57.4254 53.6075 56.2269C53.6075 55.0284 52.6359 54.0567 51.4374 54.0567H48.9494V52.8503C54.6258 51.8241 58.9448 46.8474 58.9448 40.88Z",
    fill: "url(#paint4_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 50.2232C39.5283 50.6636 40.0928 51.0585 40.6876 51.4039C40.6902 51.4054 40.6932 51.4068 40.6958 51.4083C41.3125 50.8628 41.8722 50.254 42.3671 49.5947C42.8241 48.9859 43.5506 48.6404 44.3104 48.6894C44.8067 48.721 45.3049 48.7054 45.7983 48.6428L45.7974 48.6426C44.2844 48.4522 42.9039 47.8292 41.786 46.9003C41.0623 48.1647 40.1188 49.29 39 50.2232Z",
    fill: "url(#paint5_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0031 41.6793C38.893 42.763 38.556 43.8114 38.0141 44.7563C37.327 43.5569 36.9483 42.1584 36.9871 40.6713C37.0219 39.3447 37.3919 38.0956 38.0164 37.0077C38.762 35.7072 39.8704 34.6367 41.2033 33.9386C42.188 33.4231 43.2723 33.1257 44.3822 33.0666C44.8645 33.0405 45.3373 33.0587 45.7982 33.1172C44.2858 33.3093 42.9062 33.9347 41.7891 34.8644C40.2554 36.1404 39.2158 37.9896 39.0031 40.0807V40.0815C38.9754 40.344 38.962 40.6104 38.962 40.88C38.962 41.1496 38.9754 41.416 39.0031 41.6785V41.6793Z",
    fill: "url(#paint6_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9451 40.88C58.9451 34.1726 53.4877 28.7152 46.7804 28.7152C46.2444 28.7152 45.7167 28.7505 45.1989 28.8181C51.1614 29.5962 55.7812 34.7088 55.7812 40.88C55.7812 46.6623 51.726 51.5144 46.31 52.7435C46.0049 52.8127 45.7858 53.0798 45.7858 53.3926C45.7858 53.5688 45.8558 53.7377 45.9803 53.8622C46.1049 53.9868 46.2738 54.0567 46.4499 54.0567H48.2286C49.4111 54.0567 50.4107 54.9838 50.4432 56.1659C50.4768 57.3923 49.4926 58.3971 48.2739 58.3971H46.2587C46.1333 58.3971 46.013 58.4469 45.9244 58.5355C45.8357 58.6242 45.7859 58.7444 45.7859 58.8698C45.7859 59.4443 45.5625 59.9662 45.1982 60.3544C45.595 60.777 46.1587 61.0411 46.7845 61.04C47.9885 61.0378 48.9498 60.0285 48.9498 58.8244V58.3971H51.3927C52.5751 58.3971 53.5747 57.4699 53.6072 56.2879C53.6409 55.0615 52.6567 54.0567 51.4379 54.0567H48.9499V52.8503C54.6262 51.8241 58.9451 46.8474 58.9451 40.88Z",
    fill: "url(#paint7_linear_1875_195840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3934 40.88C23.3934 36.9002 26.38 33.6048 30.2297 33.1173C29.9017 33.0758 29.5715 33.055 29.2409 33.0551C24.9262 33.0551 21.416 36.5653 21.416 40.88C21.416 45.1946 24.9263 48.7049 29.2409 48.7049C29.5758 48.7049 29.9057 48.6837 30.2297 48.6427C26.38 48.1552 23.3934 44.8598 23.3934 40.88Z",
    fill: "url(#paint8_linear_1875_195840)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1875_195840",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1875_195840"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1875_195840",
    result: "effect2_dropShadow_1875_195840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1875_195840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1875_195840",
    x1: 31.0238,
    y1: 44.8777,
    x2: 60.0365,
    y2: 44.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1875_195840",
    x1: 20.1144,
    y1: 36.8823,
    x2: 43.6368,
    y2: 36.8823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1875_195840",
    x1: 17.4954,
    y1: 23.9012,
    x2: 41.1312,
    y2: 23.9012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1875_195840",
    x1: 17.4956,
    y1: 39.3195,
    x2: 41.1314,
    y2: 39.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1875_195840",
    x1: 31.0238,
    y1: 44.8776,
    x2: 60.0368,
    y2: 44.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1875_195840",
    x1: 34.4538,
    y1: 49.1543,
    x2: 47.6649,
    y2: 49.1543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1875_195840",
    x1: 31.0904,
    y1: 38.9056,
    x2: 48.2183,
    y2: 38.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1875_195840",
    x1: 28.1157,
    y1: 44.8776,
    x2: 56.2685,
    y2: 44.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1875_195840",
    x1: 14.1746,
    y1: 40.88,
    x2: 33.2357,
    y2: 40.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F66D0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1875_195840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.32,
    height: 40.32,
    fill: "white",
    transform: "translate(18.8398 20.72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchMakers);
export default __webpack_public_path__ + "static/media/match_makers.95721e5e241b9433511806d00b220460.svg";
export { ForwardRef as ReactComponent };